import useRequest from '@/websdk/utils/request';
export default (function () {
  const {exec, data,isRequestSuccessed } = useRequest({
    name: 'GET_CRAFT_TEMPLATE',
    url: `/api/craft/templates`,
    method:'GET'
  });
 

  return [data || [], exec,isRequestSuccessed];
});
